// Component
const CartTable = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "cart-table" */ "@/app/views/main-view/products/components/cart-table/cart-table.vue"
	)
const ModalSuccessPayment = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-success-payment"*/ "@/app/views/main-view/products/containers/modals/modal-success-payment/modal-success-payment.vue"
	)
const ModalSavedAddresses = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-saved-addresses"*/ "@/app/views/main-view/products/containers/modals/modal-saved-addresses/modal-saved-addresses.vue"
	)
const CartCard = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "cart-card" */ "@/app/views/main-view/products/components/cart-card/cart-card.vue"
	)

// Third party libraries
import { StripeElementCard } from "@vue-stripe/vue-stripe"

// Utils
import { vuelidateUtil } from "@/utils/vuelidate-util.js"

// Services
import addressFinderAutocompleteService from "@/app/services/address-finder/address-finder-autocomplete/address-finder-autocomplete-service.js"
import paymentService from "@/app/services/main/payment/payment-service.js"
import storeCreditService from "@/app/services/main/store-credit/store-credit-service.js"
import userService from "@/app/services/main/user/user-service.js"
import CartService from "@/app/services/main/cart/cart-service.js"

// Constants
import { STATUS_CODES, SUCCESS_MSG } from "@/app/constants/status-constants"
import { GA } from "@/app/constants/ga-constants"
const ADDRESS_TYPE = { SHIPPING: "SHIPPING", BILLING: "BILLING"};

// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { inputTextMixins } from "@/app/mixins/utils/input-text-mixins"
import { shoppingMixins } from "@/app/mixins/components/shopping-mixins"
import { userMixins } from "@/app/mixins/modules/user-mixins"
import { switchPetMixins } from "@/app/mixins/modules/switch-pet-mixins"
import { GoogleAnalyticsMixins } from "@/app/mixins/utils/google-analytics-mixins"

// Event Bus
import EventBus from "@/app/bus/event-bus.js"

let initialStoreCredit = 0
export default {
	name: "ProductCheckoutContainer",
	mixins: [toastMessageMixins, inputTextMixins, shoppingMixins, userMixins, switchPetMixins, GoogleAnalyticsMixins],
	components: {
		StripeElementCard,
		CartTable,
		ModalSuccessPayment,
		CartCard,
		ModalSavedAddresses,
	},
	data() {
		return {
			// container
			inputFields: {
				name: "",
				firstName: "",
				lastName: "",
				email: "",
				address: "",
				billingAddress: "",
				mobileNumber: "",
			},
			checkoutStatus: {
				status: "",
				message: "",
			},
			sameAddress: false,

			// cart
			bundleIdsToDelete: [],
			subscriptionData: [],
			nonSubProducts: [],
			currentPage: null,

			// - cart validation
			cancelCheckoutValidation: true,

			// store credit
			storeCredit: 0,

			// delivery
			deliveryMin: process.env.VUE_APP_DELIVERY_MIN,
			deliveryFee: process.env.VUE_APP_DELIVERY_FEE,
			isAllowStoreCreditInBundle: true,

			// address
			addressList: [],
			isAddressLoading: false,
			isBillAddressLoading: false,
			selectedPayment: "",
			selectedPaymentStoreCredit: "",
			selectedAddressType: "",

			// stripe
			isAPILoading: false,
			isStripeLoading: false,
			cardValid: false,
			publishableKey: process.env.VUE_APP_STRIPE_KEY,
			setDefaultAddress: true,
			defaultShippingAddress: "",
			defaultBillingAddress: "",
			latitudePrice: false,
			addressShipping: null,
			addressBilling: null,
			subscriptionBundle: false,
			mobileNumberIsValid: true,
			isSplitPayment: false,
			isLatitudePayLoading: false,
			itemIsDeactivated: false,
			origin: "checkout",
			priceLimit: process.env.VUE_APP_LATITUDE_PRICE_LIMIT,

			previousRoute: null,
		}
	},
	computed: {
		isNativeApp() {
			return this.$store.getters.getIsNativeApp
		},
		validationRules() {
			let fields = {
				inputFields: {
					name: {},
					email: {},
					address: {},
					billingAddress: {},
				},
			}
			if (this.selectedPayment === "latitudePay") {
				fields.inputFields.firstName = {}
				fields.inputFields.lastName = {}
			}
			fields.inputFields.mobileNumber = {}
			fields.inputFields = vuelidateUtil.setFieldsRequired(fields.inputFields, true)
			fields.inputFields = vuelidateUtil.setEmailValidation(fields.inputFields, "email")

			if (this.selectedPaymentStoreCredit === "storeCredit" && !this.isSplitPayment) {
				fields.inputFields.billingAddress = vuelidateUtil.setFieldsRequired(
					fields.inputFields.billingAddress,
					false,
					[]
				)
			}

			return fields
		},
		selectedTable: {
			get() {
				return this.$store.getters.getSelectedCartTable
			},
			set(value) {
				this.$store.commit("setSelectedCartTable", value)
			},
		},
		isItemChanged() {
			return this.$store.getters.getIsProductChanged
		},
		isItemDeactivated() {
			return this.$store.getters.getIsProductDeactivated
		},
		isItemOutOfStock() {
			return this.$store.getters.getIsProductOutOfStock
		},
		isCartCheckoutEnabled() {
			return this.$store.getters.getIsCheckoutEnabled
		},
		disabledSubmitButton() {
			if (this.selectedPayment !== "" || 
				this.selectedPaymentStoreCredit !== "") {
					
				if (!this.isSplitPayment &&
					this.selectedPaymentStoreCredit === "storeCredit") {
					return (
						this.$v.$invalid ||
						this.isAddressLoading ||
						this.isItemChanged ||
						this.isItemOutOfStock ||
						this.isItemDeactivated ||
						this.isCartCheckoutEnabled ||
						!this.mobileNumberIsValid
					)
				} else if (this.selectedPayment === "latitudePay") {
					return (
						this.$v.$invalid ||
						this.isAddressLoading ||
						this.isItemChanged ||
						this.isItemDeactivated ||
						this.isItemOutOfStock ||
						!this.mobileNumberIsValid
					)
				} else {

					// Split payment with Stripe
					return (
						this.$v.$invalid ||
						this.isStripeLoading ||
						this.isAddressLoading ||
						this.isAPILoading ||
						!this.cardValid ||
						this.isItemChanged ||
						this.isItemDeactivated ||
						this.isItemOutOfStock ||
						!this.mobileNumberIsValid
					)
				}
			} else {
				return true
			}
		},
		disabledAPICall() {
			if (this.selectedPaymentStoreCredit === "storeCredit" || this.selectedPayment === "latitudePay") {
				return (
					this.$v.$invalid ||
					this.isAddressLoading ||
					this.isItemChanged ||
					this.isItemOutOfStock ||
					this.isItemDeactivated ||
					!this.mobileNumberIsValid
				)
			} else {
				return (
					this.$v.$invalid ||
					this.isAddressLoading ||
					!this.cardValid ||
					this.isItemChanged ||
					this.isItemOutOfStock ||
					this.isItemDeactivated ||
					!this.mobileNumberIsValid
				)
			}
		},
		getSelectedCardContentId() {
			return this.$store.getters.getSelectedCartContent.map((cart) => cart.bundleId)
		},
		getSelectedCart() {
			return this.$store.getters.getSelectedCartContent
		},
	},
	async mounted() {
		// Send Analytics
		this.sendEventTrackingToGA(
			GA.CHECKOUT_PAGE.ON_PAGE_LOAD.ACTION,
			GA.CHECKOUT_PAGE.CATEGORY,
			GA.CHECKOUT_PAGE.ON_PAGE_LOAD.LABEL
		)

		// wait for the stripe element to be fully rendered
		setTimeout(() => {
			this.cardOnChange()
		}, 1000)

		await this.getStoreCredit()
		

		window.scrollTo(0, 0)
		this.createLatitudeScript()
	},
	watch: {
		sameAddress() {
			if (this.sameAddress) {
				this.inputFields.billingAddress = this.inputFields.address
				this.$v.inputFields.billingAddress.$touch()
			} else {
				this.inputFields.billingAddress = ""
			}
		},
		selectedPaymentStoreCredit(newVal) {
			if (newVal === "storeCredit") {
				this.selectedPaymentStoreCredit = "storeCredit"
				this.selectedPayment = ''
				this.verifyStoreCreditBalance()
			} 
		},
		selectedPayment(newVal) {
			if (newVal === "latitudePay") {
				if (this.getTotalPrice >= this.priceLimit) {
					const toPay = this.isSplitPayment ? this.getTotalPrice - this.storeCredit : this.getTotalPrice
					this.isLatitudePayLoading = this.latitudePrice ? false : true
					// if (this.isSplitPayment) {
					// 	this.verifyLatitudeInterestTotalAmountToPay(toPay)
					// }
				} else {
					this.latitudePrice = false
					this.isLatitudePayLoading = false
				}
			} else if (newVal === "storeCredit") {
				this.verifyStoreCreditBalance()
			} else if (newVal === "stripe") {
				// wait for the stripe element to be fully rendered
				setTimeout(() => {
					this.cardOnChange()
				}, 1000)
			}

			if (newVal === "stripe" || newVal === "latitudePay") {
				if (this.getTotalPrice < parseFloat(this.storeCredit)) {
					this.selectedPaymentStoreCredit = ''
				}
			}
			
			// refresh cart
			this.isCheckoutEnabled()
			this.getCartList()
		},
	},

	async created() {
		if (window.location.pathname) {
			this.currentPage = window.location.pathname.substring(1)
		}

		if (this.$route.query && this.$route.query.from) {
			const from = this.$route.query.from

			if (from.includes("details")) {
				this.previousRoute = "Product Details"
			} else if (from.includes("cart")) {
				this.previousRoute = "Cart"
			}
		}
		
		const { firstName, lastName, mobileNumber } = this.getUserDetails()
		await this.getCartList()
		this.inputFields.name = this.getUserName
		this.inputFields.email = this.getUserEmail
		this.inputFields.firstName = firstName
		this.inputFields.lastName = lastName
		this.inputFields.mobileNumber = mobileNumber
		await this.$store.dispatch("generateIdempotencyKey")
		await this.userAddress()
		await this.setSelectedPayment()
		await this.setPendingOrderCount(this.getActivePet.id)
	
		await this.getStoreCredit()
		//Workaround to forcely set the store credit
		this.storeCredit = parseFloat(initialStoreCredit)

		// this.isAllowStoreCreditInBundle = this.storeCredit !== 0 
	},
	methods: {
		// CART
		// - Cart List

		async getCartList() {
			
			this.isAPILoading = true

			try{
				const res = await CartService.getCart(this.getActivePet.id, { f_type: "products" })
				if (res.status === STATUS_CODES.SUCCESS) {
					await this.setSelectedProduct(res.data)
					this.isCheckoutEnabled()
				} else {
					this.showAPIErrorToast("", res)
				}
			}
			catch(err){
				this.showGenericErrorToast();
			}
			finally{
				this.isAPILoading = false
			}

		},

		async setSelectedProduct(cartData) {
			let nonSubscription = []
			await cartData.forEach((item) => {
				if (!item.subscriptionBundle) {
					nonSubscription.push(item)
				}
			})
			let selected = "nonSub"
			if (this.$route.query && this.$route.query.bundle) {
				
				selected = this.$route.query.bundle
				const subscriptionItem = JSON.parse(
					JSON.stringify(cartData.find((item) => item.bundleId == this.$route.query.bundle))
				)
				this.checkoutValidationsModal([subscriptionItem])
				this.$store.commit("setSelectedCartContent", [subscriptionItem])
			} else {
				const nonSubItems = JSON.parse(JSON.stringify(nonSubscription))
				this.nonSubProducts = nonSubItems

				if (!nonSubItems.length) {
					this.$router.replace("/products/cart")
				}

				if (nonSubItems.length && this.cancelCheckoutValidation) {
					
					this.checkoutValidationsModal(nonSubItems)
				}

				this.$store.commit("setSelectedCartContent", nonSubItems)
			}
			this.computeTotal(selected, nonSubscription, cartData)
		},

		computeTotal(selected, nonSubscription, cartData) {
			this.totalPrice = 0
			if (selected === "nonSub") {
				const tableData = nonSubscription
				for (const key in tableData) {
					if (tableData.hasOwnProperty(key)) {
						const cart = tableData[key]
						let productPrice = cart.onSale
							? parseFloat(cart.salePrice)
							: parseFloat(cart.currentBundlePrice)
						this.totalPrice += productPrice * cart.quantity
					}
				}
			} else {
				const subscriptionItem = cartData.find((item) => item.bundleId == selected)
				if (subscriptionItem) {
					this.totalPrice = parseFloat(subscriptionItem.price)
				}
			}

			let newTotalPrice = this.totalPrice;

			if(this.totalPrice <= parseFloat(this.deliveryMin)){
				newTotalPrice = this.totalPrice + parseFloat(this.deliveryFee); // include delivery fee
			}

			this.$store.commit("setSubtotalPrice", this.totalPrice);
			this.$store.commit("setTotalPrice", newTotalPrice);
		},

		async callDeleteCartAPI(bundleIds) {
			if (!this.bundleIdsToDelete.length) return

			try {
				const res = await CartService.deleteCart(this.getActivePet.id, bundleIds)
				if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
					// show toast message
					const { SUCCESS_UPDATE_CART } = this.toastMessages.cart()
					this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATE_CART)

					// refresh the table
					this.getCartList()
					EventBus.$emit("updateStoreCreditPreview")

					// refresh cart count
					this.setCartCount(this.getActivePet.id)
					this.bundleIdsToDelete = []
				} else {
					const { ERROR_DELETE_CART } = this.toastMessages.cart(cart.name)
					this.showAPIErrorToast(ERROR_DELETE_CART, res)
				}
			} catch (error) {
				this.showGenericErrorToast()
			}
		},

		async updateCartProduct(cart) {
			if (!cart.length) return

			let productDetails
			let productsToUpdate = []

			cart.forEach((product) => {
				productDetails = {
					quantity:
						product.quantity > product.products[0].productInventory.stockQty
							? product.products[0].productInventory.stockQty
							: product.quantity,
					bundleId: product.bundleId,
				}

				if (product.subscriptionBundle) {
					productDetails = {
						...productDetails,
						subscriptionPeriodCode: product.cartSubscriptionPeriod,
						paymentFrequencyCode: product.cartPaymentFrequency,
					}
				}

				productsToUpdate.push(productDetails)
			})

			const res = await CartService.putCart(this.getActivePet.id, productsToUpdate)
			try {
				if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
					// show toast message
					const { SUCCESS_UPDATE_CART } = this.toastMessages.cart()
					this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATE_CART)

					// refresh the table
					this.getCartList()
					EventBus.$emit("updateStoreCreditPreview")
				} else {
					const { ERROR_UPDATE_CART } = this.toastMessages.cart()
					if (res.data.errors.length == 2) {
						this.showCustomErrorToast(ERROR_UPDATE_CART, "Set Payment Frequency and Subscription Period")
					} else {
						const err =
							res.data.errors[0].message === "Subscription Period Code must be a string."
								? "Set Subscription Period"
								: "Set Payment Frequency"
						this.showCustomErrorToast(ERROR_UPDATE_CART, err)
					}
				}
			} catch (err) {
				this.showGenericErrorToast()
			}
		},

		// - Cart Validations
		async isCheckoutEnabled() {
			let tableData = []
			if (this.selectedTable) {
				if (this.selectedTable !== "nonSub") {
					tableData.push(this.subscriptionData.find((item) => item.bundleId === this.selectedTable))
				} else {
					tableData = this.nonSubProducts
				}
			}

			let isEnabled = false
			let isChanged = false
			let isProductOutOfStock = false
			let isDeactivated = false

			if (tableData.length > 0) {
				for (const key in tableData) {
					if (tableData.hasOwnProperty(key)) {
						const cart = tableData[key]
						isChanged = cart.isPriceChange
						isDeactivated = this.checkProductDeactivated(cart)
						isProductOutOfStock = this.checkProductOutOfStock(cart)
						// Check if price change or product has been deactivated
						if (isChanged || isDeactivated || isProductOutOfStock) {
							isEnabled = true
							break
						}
					}
				}
			} else {
				isEnabled = false
			}

			this.$store.commit("setProductChanged", isChanged)
			this.$store.commit("setProductDeactivated", isDeactivated)
			this.$store.commit("setProductOutOfStock", isProductOutOfStock)
			this.$store.commit("setCheckoutDisabled", isEnabled)
		},
		
		async checkoutValidationsModal(cart) {
			
			if ((!this.isCartCheckoutEnabled && this.cancelCheckoutValidation) && (!this.isNativeApp)) {
				return
			}

			this.cancelCheckoutValidation = false

			// Cart validations
			const productOutOfStockListTmp =  cart.filter((item) => item.isCustomBundle === false)
			this.productPriceChangeList = cart.filter((item) => item.isPriceChange === true)
			this.productInactiveList = cart.filter((item) => item.bundleStatus === "I" || item.bundleStatus === "D")
			// Get bundles with out of stock products
			this.productOutOfStockList = this.checkBundleOutOfStock(productOutOfStockListTmp)

			// Return if there is no products needs to be updated
			if (
				!this.productPriceChangeList.length &&
				!this.productInactiveList.length &&
				!this.productOutOfStockList.length
			)
				return
			const priceChangeHtmlFormat = this.productPriceChangeList.map((item) => `<li>${item.name}</li>`).join("")
			const inactiveListHtmlFormat = this.productInactiveList.map((item) => `<li>${item.name}</li>`).join("")
			const outOfStockListHtmlFormat = this.productOutOfStockList.map((item) => `<li>${item.name}</li>`).join("")

			// Modal Sections
			const priceChangeModalSection = `
                <div>
                    <p style="margin-bottom: 0.3rem"><strong>Price Changes:</strong></p>
                    <div style="margin-bottom: 0.3rem">
                        ${priceChangeHtmlFormat}
                    </div>
                </div>
            `
			const inactiveModalSection = `
                <div>
                    <p style="margin-bottom: 0.3rem"><strong>Unavaliable Products:</strong></p>
                    <div style="margin-bottom: 0.3rem">
                        ${inactiveListHtmlFormat}
                    </div>
                </div>
            `
			const outOfStockModalSection = `
                <div>
                    <p style="margin-bottom: 0.3rem"><strong>Out of Stock:</strong></p>
                    <div style="margin-bottom: 0.3rem">
                        ${outOfStockListHtmlFormat}
                    </div>
                </div>
            `
			//
			const modalContent = `
                <div>
                    <p style="margin-bottom: 0.3rem">Before checking out, please check the following items that have updates.<strong> Upon clicking "Confirm", the cart will update and removing all the unavailable items.</strong></p>
                    ${this.productPriceChangeList.length ? priceChangeModalSection : ""}
                    ${this.productInactiveList.length ? inactiveModalSection : ""}
                    ${this.productOutOfStockList.length ? outOfStockModalSection : ""}
                </div>
            `

			this.$swal({
				imageHeight: "30px",
				imageUrl: `${require("@/assets/images/_shared/dog-confirm.png")}`,
				imageAlt: "Dog Confirm",
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				title: "Cart Updates",
				html: modalContent,
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					// Delete multiple items on cart
					const productsToDelete = [...this.productInactiveList, ...this.productOutOfStockList]
					// Update price changes
					const productsToUpdate = [...this.productPriceChangeList]

					this.bundleIdsToDelete = productsToDelete.map((product) => product.bundleId)
					this.callDeleteCartAPI(this.bundleIdsToDelete)
					this.updateCartProduct(productsToUpdate)
				} else {
					this.showCart()
				}
			})
		},

		setSelectedPayment() {
			const { getSelectedCartContent } = this.$store.getters
			if (getSelectedCartContent.length > 0 && !getSelectedCartContent[0].subscriptionBundle) {
				this.getStoreCredit()
				this.subscriptionBundle = false
			} else {
				this.selectedPayment = "stripe"
				this.subscriptionBundle = true
			}
		},
		createLatitudeScript() {
			const script = document.createElement("script")
			script.src = `${process.env.VUE_APP_MERCHANT_URL}${process.env.VUE_APP_MERCHANT_ID}`
			document.body.appendChild(script)
		},
		isObjEmpty(obj) {
			// Check if obj is null or undefined
			if (obj === null || obj === undefined) {
				return true;
			}
		
			// Check if obj is an object and has no own properties
			return Object.keys(obj).length === 0;
		},

		userAddress() {
			userService.getUserAddress().then((res) => {
				if (res.status === 200) {
					const { billingAddress, shippingAddress, userAddress: userAddressDetails } = res.data.addressDetails
			
					this.defaultShippingAddress = !this.isObjEmpty(shippingAddress) ? shippingAddress : !this.isObjEmpty(userAddressDetails) ? userAddressDetails : ''
					this.defaultBillingAddress = !this.isObjEmpty(billingAddress) ? billingAddress : !this.isObjEmpty(userAddressDetails) ? userAddressDetails : ''
					
					if (shippingAddress.mobileNumber) {
						if (shippingAddress.mobileNumber.length) {
							let data = shippingAddress.mobileNumber.split("")
							data.splice(4, 0, "-")
							this.inputFields.mobileNumber = data.join("")
							this.mobileNumberIsValid = true
						}
					}

					if (this.defaultShippingAddress.referenceId) {
						this.inputFields.address = {
							id: this.defaultShippingAddress.referenceId,
							full_address: this.defaultShippingAddress.address,
						}
					}

					if (this.defaultBillingAddress.referenceId) {
						this.inputFields.billingAddress = {
							id: this.defaultBillingAddress.referenceId,
							full_address: this.defaultBillingAddress.address,
						}
					}

					this.addressShipping = this.defaultShippingAddress
					this.addressBilling = this.defaultBillingAddress
				}
			})
		},
		processAddress(type) {
			if (type === "shipping" && this.addressShipping) {
				this.addressShipping = {
					address: this.addressShipping.full_address,
					referenceId: this.addressShipping.id,
					addressType: ADDRESS_TYPE.SHIPPING,
					addressLine1: this.addressShipping.address_line_1,
					addressLine2: this.addressShipping.address_line_2,
					suburb: this.addressShipping.locality_name,
					cityTown: this.addressShipping.lga_name,
					state: this.addressShipping.state_territory,
					postcode: this.addressShipping.postcode,
					country: "Australia",
				}
			} else {
				if (this.addressBilling) {
					this.addressBilling = {
						address: this.addressBilling.full_address,
						referenceId: this.addressBilling.id,
						addressType: ADDRESS_TYPE.BILLING,
						addressLine1: this.addressBilling.address_line_1,
						addressLine2: this.addressBilling.address_line_2,
						suburb: this.addressBilling.locality_name,
						cityTown: this.addressBilling.lga_name,
						state: this.addressBilling.state_territory,
						postcode: this.addressBilling.postcode,
						country: "Australia",
					}
				}
			}
		},
		async postUserAddress() {
			const { firstName, lastName } = this.userDetails
			let address = []

			let shipAddress = this.addressShipping || {};
			let billAddress = this.addressBilling || {};

			shipAddress.firstName = firstName
			shipAddress.lastName = lastName
			shipAddress.mobileNumber = this.inputFields.mobileNumber.replace("-", "")
			shipAddress.isDefault = 1
			shipAddress.addressType = ADDRESS_TYPE.SHIPPING

			address = [shipAddress]
			await userService.postUserAddress({ address })

			// only save the billing address if the payment method is NOT storeCredit
			if (this.isSplitPayment || this.selectedPaymentStoreCredit !== "storeCredit") {
				billAddress.firstName = firstName
				billAddress.lastName = lastName
				billAddress.mobileNumber = this.inputFields.mobileNumber.replace("-", "")
				billAddress.isDefault = 1
				
				if (this.sameAddress) {
					billAddress = this.addressShipping
				}

				billAddress.addressType = ADDRESS_TYPE.BILLING

				address = [billAddress]
				await userService.postUserAddress({ address })
			}

		},
		getStoreCredit() {
			storeCreditService
				.getStoreCredit()
				.then((res) => {
					if (res.status === 200) {
						this.storeCredit = res.data.data.amount
						initialStoreCredit = res.data.data.amount
						// this.setSelectedPaymentMethod()

						//Workaround to forcely set the store credit
						this.storeCredit = parseFloat(initialStoreCredit)
						if(!this.subscriptionBundle) {
							this.isAllowStoreCreditInBundle = this.storeCredit !== 0 
						} else {
							this.isAllowStoreCreditInBundle = this.storeCredit !== 0 && this.storeCredit >= this.getTotalPrice
						}
						
					}
				})
				.catch(() => {
					this.showGenericErrorToast()
				})
		},
		setSelectedPaymentMethod() {
			if (parseFloat(this.getTotalPrice) < 20 && this.storeCredit <= 0) {
				this.selectedPayment = "stripe"
			}
			// else {
			// 	this.selectedPayment = "storeCredit"
			// }
		},
		refreshActivePetData() {
			this.$router.replace("/products/cart")
			this.$store.commit("clearSelectedCartTableAndContent")
			this.$store.commit("clearTotalPrice")
			this.$store.commit("resetIsProductDeactivated")
			this.$store.commit("resetIsProductChanged")
			this.$store.commit("clearIdempotencyKey")

			this.setPendingOrderCount(this.getActivePet.id)
		},
		cardOnChange() {
			const stripeEl = this.$refs.stripeElement
			const element = stripeEl && stripeEl.element

			if (stripeEl && element) {
				element.on("change", (e) => {
					this.cardValid = e.complete
				})
			}
		},
		async checkoutValidationsBundleModal() {
			const { getSelectedCartContent } = this.$store.getters
			
			// Get bundles with out of stock products
			this.productOutOfStockList = this.checkBundleOutOfStock(getSelectedCartContent)

			// Return if there is no products needs to be updated
			if (!this.productOutOfStockList.length)
				return

			let bundleId = 0;
			const outOfStockListHtmlFormat = this.productOutOfStockList.map((item) => {
				if (item.isCustomBundle) {
					if ( item.id !== bundleId) {
						bundleId = item.id
						const productItem = item.products.filter(product => product.productInventory.stockQty <= 0 || !product.productInventory.stockQty)
						return productItem.map((item) => `<li>${item.name}</li>`).join("")
					}
				} else {
					return `<li>${item.name}</li>`
				}

			}).join("")

			// Modal Sections
			
			const outOfStockModalSection = `
                <div>
                    <p style="margin-bottom: 0.3rem"><strong>Out of Stock:</strong></p>
                    <div style="margin-bottom: 0.3rem">
                        ${outOfStockListHtmlFormat}
                    </div>
                </div>
            `
			//
			const modalContent = `
                <div>
                    <p style="margin-bottom: 0.3rem">Out of stock products will be delivered once available</p>
                    ${this.productOutOfStockList.length ? outOfStockModalSection : ""}
                </div>
            `

			this.$swal({
				imageHeight: "30px",
				imageUrl: `${require("@/assets/images/_shared/dog-confirm.png")}`,
				imageAlt: "Dog Confirm",
				confirmButtonText: "Proceed",
				showCancelButton: true,
				title: "",
				html: modalContent,
				allowOutsideClick: false,
				reverseButtons: true,
				allowEscapeKey: false,
			}).then((result) => {
				if (result.value) {
					if (this.setDefaultAddress) {
						this.postUserAddress()
					}
		
					if (!this.isSplitPayment 
						&&this.selectedPaymentStoreCredit === "storeCredit") {
						this.storeCreditPayment()
					} else if (this.selectedPayment === "latitudePay") {
						this.latitudePayInterestFree()
					} else {
						this.$refs.stripeElement.submit()
					}
				} 
			})
		},
		onSubmitPayment(e) {
			e.preventDefault()
			if (this.disabledAPICall) {
				this.isAPILoading = false
				return
			}

			const { getSelectedCartContent } = this.$store.getters
			// Get bundles with out of stock products
			this.productOutOfStockList = this.checkBundleOutOfStock(getSelectedCartContent)

			if(this.productOutOfStockList.length) {
				this.checkoutValidationsBundleModal()
			} else {
				if (this.setDefaultAddress) {
					this.postUserAddress()
				}
	
				if (!this.isSplitPayment 
					&&this.selectedPaymentStoreCredit === "storeCredit") {
					this.storeCreditPayment()
				} else if (this.selectedPayment === "latitudePay") {
					this.latitudePayInterestFree()
				} else {
					this.$refs.stripeElement.submit()
				}
			}
		},

		verifyLatitudeInterestTotalAmountToPay(toPay) {
			if (toPay > parseFloat(this.priceLimit)) {
				this.$swal({
					imageHeight: "30px",
					imageUrl: `${require("@/assets/images/_shared/sad-dog.png")}`,
					imageAlt: "Sad Dog",
					titleText: `Insufficient Amount To Pay`,
					text: `Total amount to be paid using latitude interest free should be greater than or equal to ${parseFloat(this.priceLimit)}.`,
					customClass: {
						header: "header-social-club",
						title: "title-social-club",
					},
					confirmButtonText: "Close",
				}).then((result) => {
					if (result.value) {
						this.isSplitPayment = true
						// insert Split Payment methods etc.
						this.selectedPayment = ""
					} else {
						this.isSplitPayment = false
						this.selectedPayment = ""
					}
				})
			}
		},

		verifyStoreCreditBalance() {
			if (this.getTotalPrice > parseFloat(this.storeCredit) && parseFloat(this.storeCredit) !== 0) {
				this.$swal({
					imageHeight: "30px",
					imageUrl: `${require("@/assets/images/_shared/sad-dog.png")}`,
					imageAlt: "Sad Dog",
					titleText: `Insufficient Store Credit`,
					html: " <strong>Would you like to split the payment with your remaining store credit and another payment method?</strong>",
					confirmButtonText: "Yes",
					cancelButtonText: "No",
					customClass: {
						header: "header-social-club",
						title: "title-social-club",
					},
					showCancelButton: true,
					reverseButtons: true,
				}).then((result) => {
					if (result.value) {
						this.isSplitPayment = true
						// insert Split Payment methods etc.
					} else {
						this.isSplitPayment = false
						this.selectedPaymentStoreCredit = ""
					}
				})
			}
		},
		cancelSplitPayment() {
			this.selectedPaymentStoreCredit = ""
			this.selectedPayment = ""
			this.isSplitPayment = false
		},
		storeCreditPayment() {
			if (this.getTotalPrice <= this.storeCredit) {
				this.$swal({
					imageHeight: "30px",
					imageUrl: `${require("@/assets/images/_shared/dog-confirm.png")}`,
					imageAlt: "Confirm Dog",
					titleText: `Place Order`,
					text: "Please confirm your purchase",
					confirmButtonText: "Confirm",
					cancelButtonText: "Cancel",
					customClass: {
						header: "header-social-club",
						title: "title-social-club",
					},
					showCancelButton: true,
					reverseButtons: true,
				}).then((result) => {
					if (result.value) {
						this.callStoreCreditPaymentAPI()
					}
				})
			}
		},
		callStoreCreditPaymentAPI() {
			this.isAPILoading = true

			this.checkoutStatus = {
				status: "",
				message: "",
			}

			this.$store.commit("setIsCheckoutFlag", true)
			const petId = this.getActivePet.id
			const chargeDetails = {
				name: this.inputFields.name,
				email: this.inputFields.email,
				mobileNumber: this.inputFields.mobileNumber.replace("-", ""),
				address: this.inputFields.address.full_address,
				bundleIds: this.getSelectedCardContentId,
				//id 3 for Store Credit Payment - from paymentMethod table
				paymentMethod: 3,
				// order address
				shipAddress: this.addressShipping,
				billAddress: this.addressBilling,
			}

			storeCreditService
				.chargeStoreCredit(petId, chargeDetails)
				.then((res) => {
					this.isAPILoading = false
					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						// Clear IdempotencyKey and Selected Cart
						this.$store.commit("clearIdempotencyKey")
						this.$store.commit("setIsCheckoutFlag", false)

						// Send Analytics
						this.sendEventTrackingToGA(
							GA.CHECKOUT_PAGE.STORE_CREDIT_BUTTON.ACTION,
							GA.CHECKOUT_PAGE.CATEGORY,
							GA.CHECKOUT_PAGE.STORE_CREDIT_BUTTON.LABEL
						)

						// Show success payment modal with a table of ordered bundle/products
						this.showSuccessModal()
					} else {
						const { ERROR_CHARGE_PAYMENT } = this.toastMessages.payment()
						this.$store.commit("setIsCheckoutFlag", false)

						if (res.data.errors && res.data.errors.some((e) => e.message === "Bundle is not available.")) {
							this.disableProduct()
						} else {
							this.checkoutStatus = {
								status: "failed",
								message: `${ERROR_CHARGE_PAYMENT}: ${res.data.errors[0].message}`,
							}
						}

						// Send Analytics
						this.sendEventTrackingToGA(
							GA.CHECKOUT_PAGE.ERROR,
							GA.CHECKOUT_PAGE.CATEGORY,
							GA.CHECKOUT_PAGE.STORE_CREDIT_BUTTON.LABEL
						)
					}
				})
				.catch(() => {
					// Send Analytics
					this.sendEventTrackingToGA(
						GA.CHECKOUT_PAGE.ERROR,
						GA.CHECKOUT_PAGE.CATEGORY,
						GA.CHECKOUT_PAGE.STORE_CREDIT_BUTTON.LABEL
					)

					this.showGenericErrorToast()
					this.isAPILoading = false
				})
		},
		tokenCreated(token) {
			if (this.disabledAPICall) {
				this.isAPILoading = false
				return
			}
			this.callPaymentAPI(token)
		},
		callPaymentAPI(token) {
			this.isAPILoading = true

			this.checkoutStatus = {
				status: "",
				message: "",
			}

			this.$store.commit("setIsCheckoutFlag", true)

			const petId = this.getActivePet.id
			const paymentDetails = {
				tokenId: token.id,
				name: this.inputFields.name,
				email: this.inputFields.email,
				mobileNumber: this.inputFields.mobileNumber.replace("-", ""),
				address: this.inputFields.address.full_address,
				bundleIds: this.getSelectedCardContentId,
				splitPayment: this.isSplitPayment,
				//id 1 for Stripe - from paymentMethod table
				paymentMethod: 1,
				// order address
				shipAddress: this.addressShipping,
				billAddress: this.sameAddress ? {...this.addressShipping, addressType: ADDRESS_TYPE.BILLING}: this.addressBilling,
			}

			paymentService
				.chargePayment(petId, paymentDetails)
				.then((res) => {
					this.isAPILoading = false
					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						// Clear IdempotencyKey and Selected Cart
						this.$store.commit("clearIdempotencyKey")
						this.$store.commit("setIsCheckoutFlag", false)

						// Send Analytics
						this.sendEventTrackingToGA(
							GA.CHECKOUT_PAGE.STRIPE_BUTTON.ACTION,
							GA.CHECKOUT_PAGE.CATEGORY,
							GA.CHECKOUT_PAGE.STRIPE_BUTTON.LABEL
						)

						// Show success payment modal with a table of ordered bundle/products
						this.showSuccessModal()
					} else {
						// Send Analytics
						this.sendEventTrackingToGA(
							GA.CHECKOUT_PAGE.ERROR,
							GA.CHECKOUT_PAGE.CATEGORY,
							GA.CHECKOUT_PAGE.STRIPE_BUTTON.LABEL
						)

						const { ERROR_CHARGE_PAYMENT } = this.toastMessages.payment()
						this.$store.commit("setIsCheckoutFlag", false)

						if (res.data.errors && res.data.errors.some((e) => e.message === "Bundle is not available.")) {
							this.disableProduct()
						} else {
							this.checkoutStatus = {
								status: "failed",
								message: `${ERROR_CHARGE_PAYMENT}: ${res.data.errors[0].message}`,
							}
						}
					}
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isAPILoading = false
				})
		},
		disableProduct() {
			this.$store.commit("setProductDeactivated", true)
			this.$store.commit("setCheckoutDisabled", true)
		},
		async onSelectAddress(field) {
			if (field === "address") {
				this.$v.inputFields.address.$touch()
				this.addressShipping = await this.getAddressMetaData(this.inputFields.address)
				this.processAddress("shipping")

				if (this.sameAddress) {
					this.inputFields.billingAddress = this.inputFields.address
					this.$v.inputFields.billingAddress.$touch()
					this.addressBilling = this.addressShipping
					this.processAddress("billing")
				}
			}

			if (field === "billingAddress") {
				this.$v.inputFields.billingAddress.$touch()
				this.addressBilling = await this.getAddressMetaData(this.inputFields.billingAddress)
				this.processAddress("billing")
			}
		},
		findAddress(address, type) {
			if (address) {
				if (type === "shipping") {
					this.isAddressLoading = true
				} else {
					this.isBillAddressLoading = true
				}

				this.delayTyping(() => {
					this.getAutocompleteAddress(address)
				})
			}
		},
		getAutocompleteAddress(address) {
			addressFinderAutocompleteService
				.getAutocompleteAddress(address)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.addressList = res.data.completions
						this.isAddressLoading = false
						this.isBillAddressLoading = false
					} else {
						const { ERROR_GET_ADDRESS } = this.toastMessages.addressFinder()
						this.showAPIErrorToast(ERROR_GET_ADDRESS, res)
						this.isAddressLoading = false
						this.isBillAddressLoading = false
					}
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isAddressLoading = false
					this.isBillAddressLoading = false
				})
		},
		showSuccessModal() {
			if (this.isNativeApp) {
				setTimeout(function () {
					window.ReactNativeWebView.postMessage("SuccessPayment")
				}, 0)
			}
			this.$refs.modalSuccessPayment.openModal()
		},
		async getAddressMetaData(address) {
			if(!address) return;

			return addressFinderAutocompleteService
				.getAddressMetaData(address.id)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						return res.data
					} else {
						const { ERROR_GET_ADDRESS } = this.toastMessages.addressFinder()
						this.showAPIErrorToast(ERROR_GET_ADDRESS, res)
						this.isAddressLoading = false
						this.isBillAddressLoading = false
					}
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isAddressLoading = false
					this.isBillAddressLoading = false
				})
		},
		mobileNumberFormat(event) {
			this.mobileNumberIsValid = true

			this.inputFields.mobileNumber = this.formatMobileNumberOnChange(event);

			/*
			let regexp = /^\d+$/

			let updateData = regexp.test(event.target.value.charAt(event.target.value.length - 1))

			if (updateData && event.target.value.length <= 11) {
				if (event.target.value.length === 5 && updateData) {
					let data = event.target.value.split("")
					if (event.target.value.charAt(4) === "-") {
						data.splice()
					} else {
						data.splice(4, 0, "-")
					}
					if (!updateData) {
						data.slice(0, -1)
					}
					data = data.join("")

					this.inputFields.mobileNumber = data
				} else {
					this.inputFields.mobileNumber = event.target.value
				}
			} else {
				this.inputFields.mobileNumber = event.target.value.slice(0, -1)
			} */
		},
		onPasteMobileNumber(event) {
			event.preventDefault(); // Prevent default paste behavior
			const pastedText = event.clipboardData.getData('text/plain');

			const formatMobileNumberOnPaste = this.formatMobileNumberOnPaste(pastedText)
			event.target.value = formatMobileNumberOnPaste;
		},
		checkFormat() {
			this.$v.inputFields.mobileNumber.$touch()

			let regexp = /^\d{4}-\d{6}$/

			if (this.inputFields.mobileNumber !== null && this.inputFields.mobileNumber !== "") {
				this.mobileNumberIsValid = regexp.test(this.inputFields.mobileNumber)
			} else {
				this.mobileNumberIsValid = true
			}
		},
		submitForm() {
			this.$refs.form.submit()
			// this.$refs.form.submit().preventDefault();
		},
		async latitudePayInterestFree() {
			try {
				let addressBilling
				this.isAPILoading = true

				if(!this.addressShipping.addressLine1 || !this.addressShipping.cityTown){
					const metadata = await this.getAddressMetaData({id: this.addressShipping.referenceId});
					this.addressShipping.addressLine1 = metadata.address_line_1;
					this.addressShipping.addressLine2 = metadata.address_line_2;
					this.addressShipping.cityTown = metadata.lga_name;
				}
				const shippingAddress = {
					address: this.addressShipping.address,
					addressLine1: this.addressShipping.addressLine1 || "N/A",
					addressLine2: this.addressShipping.addressLine2,
					suburb: this.addressShipping.suburb,
					cityTown: this.addressShipping.cityTown || "N/A",
					state: this.addressShipping.state,
					postcode: this.addressShipping.postcode,
					countryCode: "AU",
					country: this.addressShipping.country || "Australia",
				}

				if (this.sameAddress) {
					addressBilling = shippingAddress
				} else {
					addressBilling = {
						address: this.addressBilling.address,
						addressLine1: this.addressBilling.addressLine1 || "N/A",
						addressLine2: this.addressBilling.addressLine2 || "N/A",
						suburb: this.addressBilling.suburb,
						cityTown: this.addressBilling.cityTown || "N/A",
						state: this.addressBilling.state,
						postcode: this.addressBilling.postcode,
						countryCode: "AU",
						country: this.addressShipping.country || "Australia",
					}
				}

				const paymentDetails = {
					customer: {
						mobileNumber: this.inputFields.mobileNumber.replace("-", ""),
						firstName: this.inputFields.firstName,
						surname: this.inputFields.lastName,
						email: this.inputFields.email,
					},
					shippingAddress: shippingAddress,
					billingAddress: addressBilling,
					petId: this.getActivePet.id,
					bundleIds: this.getSelectedCardContentId,
					splitPayment: this.isSplitPayment,
				}

				const response = await paymentService.proceedProductToLatitudeInterestFree(paymentDetails)

				if (response.status === STATUS_CODES.SUCCESS) {
					let url
					const { redirectUrl } = response.data
					url = redirectUrl

					this.redirectToLpInterestFree(url)

					this.isAPILoading = false
				} else {
					this.showAPIErrorToast("Unable to Process Checkout.", response)
					this.isAPILoading = false
				}
			} catch (error) {
				this.showGenericErrorToast()
				this.isAPILoading = false
			}
		},

		redirectToLpInterestFree(url) {
			const latitudeInterestFreeImg = require("@/assets/images/_shared/latitude-interest-free-logo.svg")
			this.$swal({
				title: "Redirecting to ...",
				html: `<img style='width: 300px' src=${latitudeInterestFreeImg}>`,
				allowOutsideClick: false,
				timer: 2000,
				showCancelButton: false,
				showConfirmButton: false,
			}).then(() => {
				window.location = url
			})
		},
		viewAddresses(addressType){
			if (this.isNativeApp) {
				setTimeout(function () {
					window.ReactNativeWebView.postMessage("ModalAddresses")
				}, 0)
			}
			const defaultSelectedAddress = addressType === ADDRESS_TYPE.SHIPPING ? this.addressShipping : this.addressBilling;
			this.$refs.modalSavedAddresses.openModal(addressType, defaultSelectedAddress);
			this.selectedAddressType = addressType;
		},
		async onSelectFromSavedAddresses(selectedAddress){

			if(this.selectedAddressType === ADDRESS_TYPE.SHIPPING){
				this.addressShipping = selectedAddress;

				// properly format the address to be placed in the dropdown
				this.inputFields.address = {...selectedAddress, full_address: selectedAddress.address};
			} 
			
			if(this.selectedAddressType === ADDRESS_TYPE.BILLING){
				this.addressBilling = selectedAddress;
				// properly format the address to be placed in the dropdown
				this.inputFields.billingAddress = {...selectedAddress, full_address: selectedAddress.address};
			}

		},
	},
	validations() {
		return this.validationRules
	},
	beforeRouteLeave(to, from, next) {
		to.query.fromCheckout = true
		if (this.$swal.isVisible()) {
			this.$swal.close();
		  }
		next()
	},
}
